import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {DateTime, Keyboard, NavController, NavParams, ViewController} from 'ionic-angular';

import {AFTER_LOGOUT} from "../../../app/import";
import {CONFIG} from '../../../app/config';
import {TAction, TPrivacyFlag, TReceitaNumber} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {DataService} from "../../../providers/data-service";
import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {ModalActionPage} from "../modal-action/modal-action";
import {NavRepository} from "../../../repositories/nav-repository";
import {FriendyMenuPage} from "../friendy-menu/friendy-menu";
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'page-privacy-menu',
    templateUrl: 'privacy-menu.html',
    providers: [ProfileService]
})
export class PrivacyMenuPage {

    TPrivacyFlag: any = TPrivacyFlag;

    @ViewChild('inputPassword') inputPassword: any;
    @ViewChild('inputPasscopy') inputPasscopy: any;
    @ViewChild(DateTime) iondate: DateTime;

    inputSelected: any;
    passnovo: string;
    passcopy: string;
    passdone: boolean;

    etapa: number;
    config: any;
    logado: any;
    rootile: any;
    copyile: any;
    backupe: any;

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                private keyboard: Keyboard, public util: Util, public logadoService: LogadoService,
                public profileService: ProfileService,
                public deviceService: DeviceDetectorService,
                public dataService: DataService, public navRepository: NavRepository) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.etapa = this.navParams.get('etapa');
        this.rootile = this.navParams.get('rootile');
        this.copyile = this.navParams.get('copyile');
        this.backupe = this.util.deepCopy(this.rootile);

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Menu', '/profile-menu');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

        if (this.etapa == 6) this.iondate.open();

    }

    getTitle() {

        if (this.etapa == 4) return 'Privacidade';
        if (this.etapa == 5) return 'Senha';
        if (this.etapa == 6) return 'Nascimento';

    }



    /** ************************************************* PERSONA ************************************************* **/
    /** ************************************************* etapa-4 ************************************************* **/

    onKeydown(event) {

        /**                                 //Ctrl+V "V"             //Ctrl+V "CTRL"   **/
        return (event.keyCode == 16) || (event.keyCode == 17) || (event.keyCode == 86) || (event.keyCode == 9) || (event.keyCode == 8) || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105);

    }

    onChange() {

        setTimeout(() => {
                let inputSelected = '';

                let oito = (this.passnovo || '');
                let copy = (this.passcopy || '');
                if (this.inputPassword && oito.length != 8)                     inputSelected = 'inputPassword';
                if (this.inputPasscopy && oito.length == 8 && copy.length != 8) inputSelected = 'inputPasscopy';
                if (this.inputPassword && oito.length == 8 && copy.length == 8) inputSelected = 'inputKeyboard';

                if (this.inputSelected == inputSelected) return;
                this.inputSelected = inputSelected;

                if (inputSelected == 'inputPassword') this.inputPassword.setFocus();
                if (inputSelected == 'inputPasscopy') this.inputPasscopy.setFocus();
                if (inputSelected == 'inputKeyboard' && this.util.nativeApp()) this.keyboard.close();
            }, 500
        );

    }

    profileBorn() {

        // etapa = 6 Birthday
        if (this.copyile.Profile.ReceitaCode == TReceitaNumber.rfReceitaNascido && this.rootile.Profile.ProfileBorn == this.copyile.Profile.ProfileBorn) {
            this.util.alertSimply('Precisamos da sua data de nascimento.', 'Para continuar...');
            return;
        }

        //ProfileBorn -> Cancela se não houve alteração na data de nascimento
        if (this.rootile.Profile.ProfileBorn == this.copyile.Profile.ProfileBorn) return;


        let onErro = () => {
            this.iondate.open();
        };

        let onDone = (data) => {
            this.copyile.Profile.ReceitaFlag = data.Profiles[0].ReceitaFlag;
            this.copyile.Profile.ReceitaCode = data.Profiles[0].ReceitaCode;
            this.util.populateObj(this.rootile, this.copyile);

            let okay = (this.copyile.Profile.ReceitaCode == TReceitaNumber.rfReceitaSucesso);
            if ( okay) this.dismiss();
            if (!okay) this.iondate.open();
        };

        let loading = this.util.loadingDots();
        loading.present();

        //#BORN - Adicionado o Rnid no profileFind repository!
        let params = '&ProfileRnid=' + this.copyile.Profile.ProfileRnid + '&ProfileBorn=' + this.copyile.Profile.ProfileBorn;
        this.profileService.profile(TAction.acBorn, this.copyile.Profile.ProfileID, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onDone(data),
                erro => this.util.alertResult(erro, onErro)
            );

    }

    profileSave(close) {

        let onErro = () => {
            if (this.etapa == 6) this.iondate.open();
        };

        let onDone = () => {
            this.util.populateObj(this.rootile, this.copyile);
            if (close) this.dismiss();
        };


        //Procria
        if (!this.copyile.Profile.ProfileID) {
            onDone();
            return;
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.profile(TAction.acSave, this.copyile.Profile.ProfileID, this.copyile.Profile)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onDone(),
                erro => this.util.alertResult(erro, onErro)
            );

    }



    /** ************************************************* PRIVACY ************************************************* **/
    /** ************************************************* etapa-4 ************************************************* **/

    profileHide(acLixo) {

        let onOkey = (okey, that, data) => {
            let loading = this.util.loadingDots();
            loading.present();

            this.profileService.profile(TAction.acSelf, 0, null, '&ProfileOito=' + that.modalinfo.inputf.text)
                .finally(() => loading.dismiss())
                .subscribe(data => {

                    let loading = this.util.loadingDots();
                    loading.present();

                        let action = (acLixo ? TAction.acLixo : TAction.acHide);
                        this.profileService.profile(action, this.copyile.Profile.ProfileID)
                            .finally(() => loading.dismiss())
                            .subscribe(data => {

                                    if (this.logado.Profile.ProfileID == this.copyile.Profile.ProfileID) {
                                        this.logadoService.logout();
                                        this.navRepository.afterLogout(this.navCtrl.parent.parent, AFTER_LOGOUT).subscribe();
                                    }

                                    that.dismiss();

                                }, erro => this.util.alertResult(erro)
                            );

                    }, erro => this.util.alertResult(erro)
                );
        };

        let hide = '<b>Sua conta será desativada.</b><br>' +
                    'e deixará de ser exibida.<br><br>' +
                    'Para <b>RECUPERAR</b> sua conta:<br>' +
                    '- Efetue login novamente.<br>' +
                    '- Sua conta será restaurada.<br>';

        let lixo = '<b>Sua conta será excluída.</b><br>' +
                    'e deixará de existir.';

        let resumo = (acLixo ? lixo : hide);

        //HTML Simple
        let objectData = {modalfull: true, modalinfo: this.config.modalinfo(this.util, 'profileoff', onOkey, null, acLixo, resumo)};

        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    friendyLock() {

        let object = {etapa: 2, rootile: this.rootile};
        this.util.modalopen(FriendyMenuPage, 'wide', false, object).subscribe();

    }

    dismiss() {

        //Retorna se houve modificação na privacidade para carregar cada tela!
        let root = this.rootile.Profile;
        let back = this.backupe.Profile;
        let privacyEdit = (root.PrivacySpot && root.PrivacySpot != back.PrivacySpot) ||
                          (root.PrivacyBlnd && root.PrivacyBlnd != back.PrivacyBlnd) ||
                          (root.PrivacyChip && root.PrivacyChip != back.PrivacyChip);

        this.util.populateObj(this.copyile, this.rootile);
        this.viewCtrl.dismiss({privacyEdit: privacyEdit});

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/privacy-menu/privacy-menu.ts